import { render } from "./UsersPanel.vue?vue&type=template&id=cb1a471c"
import script from "./UsersPanel.vue?vue&type=script&lang=js"
export * from "./UsersPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__